<template>
  <div class="InfiniteScroll">
    <div class="scroll_parent_box" @mouseenter="mEnter" @mouseleave="mLeave">
      <div class="scroll_list" :style="{ transform: `translate(0px,-${scrollTop}px)` }">
        <div ref="scrollItemBox">
          <div class="scroll_item" v-for="(item, index) in listData" :key="index">
            <div class="left"></div>
            {{ item.title }}
          </div>
        </div>
        <div v-html="copyHtml"></div>
      </div>
    </div>
  </div>
</template>

<script>
let timer = null;
export default {
  name: "InfiniteScroll",
  data() {
    return {
      scrollTop: 0, //列表滚动高度
      speed: 50, //滚动的速度

      listData: [
        {
          title: "无缝滚动第一行"
        },
        {
          title: "无缝滚动第二行"
        },
        {
          title: "无缝滚动第三行"
        },
        {
          title: "无缝滚动第四行"
        },
        {
          title: "无缝滚动第五行"
        },
        {
          title: "无缝滚动第六行"
        },
        {
          title: "无缝滚动第七行"
        },
        {
          title: "无缝滚动第八行"
        },
        {
          title: "无缝滚动第九行"
        },
        {
          title: "无缝滚动第十行"
        },
        {
          title: "无缝滚动第十一行"
        }
      ], //表示有多少个列表项
      copyHtml: "" //复制多一份防止滚动到后面出现空白
    };
  },
  mounted() {
    // 如果列表数据是异步获取的，记得初始化在获取数据后再调用
    this.initScroll();
  },
  beforeDestroy() {
    clearInterval(timer);
  },
  methods: {
    initScroll() {
      this.$nextTick(() => {
        this.copyHtml = this.$refs.scrollItemBox.innerHTML;
        this.startScroll();
      });
    },
    // 鼠标移入停止滚动
    mEnter() {
      clearInterval(timer);
    },
    // 鼠标移出继续滚动
    mLeave() {
      this.startScroll();
    },
    // 开始滚动
    startScroll() {
      timer = setInterval(this.scroll, this.speed);
    },
    // 滚动处理方法
    scroll() {
      this.scrollTop++;
      // 获取需要滚动的盒子的高度
      let scrollItemBox = this.$refs.scrollItemBox.offsetHeight;
      // 当判断滚动的高度大于等于盒子高度时，从头开始滚动
      if (this.scrollTop >= scrollItemBox) {
        this.scrollTop = 0;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.InfiniteScroll {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // padding: 50px;
}

.scroll_parent_box {
  width: 100%;
  height: 100%;
  // border: 1px solid #ebeef5;
  overflow: hidden;
  padding: 0 10px;
  box-sizing: border-box;
  color: #fff;
}

.scroll_list {
  transition: all 0ms ease-in 0s;
}

@keyframes mymove {
  from {
    opacity: 1;
  }
  to {
    opacity: 0.2;
  }
}

.scroll_item {
  width: 368px;
  height: 52px;
  background: linear-gradient(90deg, #0d3962 0%, rgba(7, 10, 22, 0) 100%);
  margin: 5px 0;
  padding: 5px 5px 5px 10px;
  box-sizing: border-box;
  position: relative;
  // opacity: 1;
  // animation: mymove 5s infinite;

  .left {
    width: 4px;
    height: 52px;
    background: #18adeb;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
